/**
 * AI 生文- 删除会话
 * @returns
 */
import { deleteChat } from "@/services/api/thunks/chat";
import { useAppDispatch } from "@/store/hooks";
import { MsSystem } from "@/types/mssystem";
import { ChatTopic } from "@/types/writing";
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
} from "@chakra-ui/react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  message: MsSystem;
};

const SysMsgModal = (props: Props) => {
  const { isOpen, onClose, message } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent  bg="#fff">
        <ModalHeader color="#27314D" fontSize={"18px"}>
          {message.title}
        </ModalHeader>
        {/* <ModalCloseButton color={"#B9B9B9"} /> */}
        <ModalBody pb={6}>
          <Box fontSize={"14px"} color="#27314D">
            {message.content}
          </Box>
          <Flex mt="40px" justifyContent={"flex-end"}>
            <Button
              w="76px"
              h="37px"
              bg="#496AE1"
              color={"#FFFFFF"}
              fontSize="12px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{
                bg: "#3F5BC1",
                color: "#E6E6E6",
              }}
              onClick={() => onClose()}
            >
              确定
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SysMsgModal;
